import { AuthService } from './auth.service';
import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { User } from '../models/user.interface';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public editUser: EventEmitter<boolean> = new EventEmitter<boolean>();
  public originalUser: EventEmitter<User> = new EventEmitter<User>();

  URL: string;
  _editing = false;

  constructor(
    private http: HttpClient,
    private auth: AuthService
  ) {
    this.URL = `${environment.baseServerURL}/security`;
  }

  public get editing(): boolean {
    return this._editing;
  }

  buildURL(subPath: string) {
    return `${this.URL}/user/${subPath}`;
  }

  buildURLRole(subPath: string) {
    return `${this.URL}/role/${subPath}`;
  }

  getUserList(): Observable<any> {
    return this.http.get(this.buildURL('company/' + this.auth.user.company.id), {
      withCredentials: true
    });
  }

  getUser(userId): Observable<any> {
    return this.http.get(this.buildURL(userId), {
      withCredentials: true
    });
  }

  getRoles(): Observable<any> {
    return this.http.get(this.buildURLRole(''), {
      withCredentials: true
    });
  }

  addUser(user): Observable<any> {
    return this.http.post(this.buildURL(''), user, {
      withCredentials: true
    });
  }

  sendInvitation(email, token): Observable<any> {
    return this.http.post(this.buildURL('sendInvitation'),
      {
        email: email,
        token: token
      }, {
      withCredentials: true
    });
  }

  updateUser(user): Observable<any> {
    return this.http.put(this.buildURL(user.id), user, {
      withCredentials: true
    });
  }

  deleteUser(userId): Observable<any> {
    return this.http.delete(this.buildURL('delete/' + userId), {
      withCredentials: true
    });
  }

  updatePassword(userId, password): Observable<any> {
    return this.http.patch(this.buildURL('updatePassword/' + userId), {
      password: password
    }, {
      withCredentials: true
    });
  }

  // This method provides a boolean var, in order to tell the user-single.component if the edit button was pressed in the user list.
  updateDirectUser(updating: boolean): void {
    this._editing = updating;
  }

  // This method is only used when an user for first time access to his account and assing the password
  activateUser(password: string, token: string): Observable<any> {
    return this.http.patch(this.buildURL('activateUser'), {
      password: password,
      token: token
    }, {
      withCredentials: true
    });
  }

  // resend invitation
  resendInvitation(user): Observable<any> {
    return this.http.post(this.buildURL('resendInvitation'), user, {
      withCredentials: true
    });
  }

}
